import { Component, Inject, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/uppy/user.service';
import { FormatUtil } from 'src/app/utils/format.util';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { TrainingProgramApplicationUtils } from 'src/app/utils/training-program-application.util';

@Component({
    selector: 'app-loggedin-user-name',
    templateUrl: './loggedin-user-name.component.html',
    styleUrls: ['./loggedin-user-name.component.scss'],
    standalone: false
})
export class LoggedinUserNameComponent implements OnInit {

  formatUtil = FormatUtil
  isMenuExpended: boolean = false;

  constructor(public translateService: TranslateService,
    @Inject('UserService') public userService: UserService,
    public router: Router,
    public route: ActivatedRoute) { }

  ngOnInit(): void {
    if (this.userService.currentUser == null || TrainingProgramApplicationUtils.isNullOrEmpty(this.userService.currentUser.FirstName)) {
      this.userService.GetCurrentUser().subscribe(user => {
        this.userService.currentUser = user
      })
    }
  }

  expendMenu(option: boolean) {
    this.isMenuExpended = option;
  }
  signOut() {
    this.userService.gotoLogout()
  }
}
